module.exports = __webpack_public_path__ + "static/img/5953_phase_function_Paper_PointsHejduk_Prediction.227d660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5953_phase_function_Paper_PointsHejduk_Prediction.png
// module id = UmzS
// module chunks = 0